
import Vue from 'vue'
export default Vue.extend({
  props: {
    cols: [Boolean, String, Number],
    sm: [Boolean, String, Number],
    md: [Boolean, String, Number],
    lg: [Boolean, String, Number],
    xl: [Boolean, String, Number],
  },
})
